import { PageTabs, PageTabsList, PageTabsTrigger } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { PageTabsHeader } from "../../../components/PageTabsHeader";
import { VitalsSettings } from "./VitalsSettings/VitalsSettings";

export const OrganizationSettingsPage = () => {
  const { t } = useTranslation("vitals");

  return (
    <>
      <PageTabsHeader>
        <PageTabs defaultValue="vitals" className="h-full">
          <PageTabsList>
            <PageTabsTrigger value="vitals">{t("Vitals")}</PageTabsTrigger>
          </PageTabsList>
        </PageTabs>
      </PageTabsHeader>
      <div className="flex-1 overflow-auto">
        <VitalsSettings />
      </div>
    </>
  );
};
